import styled from "styled-components";

export const WrapperTable = styled.div.attrs({
  className: "w-full overflow-y-hidden min-h-[22.5rem]",
})``;

export const StyledTable = styled.table.attrs({
  className: "table table-compact w-full table-fixed",
})``;
